import unsupportedProp from '@mui/utils/unsupportedProp';
export default unsupportedProp;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/unsupportedProp.js
// module id = 313
// module chunks = 25